export const PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_])[A-Za-z\d\W_]{8,20}$/;
export const ALPHA = /^[a-zA-Z]+$/;
export const ALPHA_WITH_SPACE = /^[a-zA-Z ]+$/;
